/*
  Colored status pill. Maps known statuses to colors,
  falls back to neutral gray.
*/
const TONES = {
  // orders
  pending: 'warn',
  confirmed: 'info',
  processing: 'info',
  shipped: 'info',
  delivered: 'ok',
  cancelled: 'bad',
  // payment
  paid: 'ok',
  refunded: 'bad',
  failed: 'bad',
  // generic
  active: 'ok',
  inactive: 'bad',
  approved: 'ok',
  rejected: 'bad',
  completed: 'ok',
  scheduled: 'info',
  admin: 'info',
  customer: 'neutral',
  // coupons
  expired: 'bad',
  'used up': 'warn',
  // stock
  'in stock': 'ok',
  'low stock': 'warn',
  'out of stock': 'bad',
};

export default function StatusBadge({ status }) {
  const label = String(status ?? '—');
  const tone = TONES[label.toLowerCase()] || 'neutral';

  return <span className={`status-badge tone-${tone}`}>{label}</span>;
}
